export const SDK_NAME = "sentry.javascript.miniapp";
export const SDK_VERSION = "1.0.7";
